export const fileUpload = {
  audio: "audio-files",
  video: "video-files",
  csv: "csv-files",
  downloads: "downloads",
};
